import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const VAT_PAYER = {
  YES: 'yes',
  NO: 'no',
} as const;

export const VAT_PAYER_NAME = 'vat_payer';

interface Props {
  name?: string;
}

export const RadioGroupVatPayer: FC<Props> = ({ name = VAT_PAYER_NAME }) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Czy jesteś czynnym płatnikiem VAT?')}</FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'horizontal'}>
              <RadioItem
                data-testid={`${name}-radio-group-${VAT_PAYER.YES}`}
                value={VAT_PAYER.YES}
                label={i18n.t('Tak')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${VAT_PAYER.NO}`}
                value={VAT_PAYER.NO}
                label={i18n.t('Nie')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
